
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/article/[id]",
      function () {
        return require("private-next-pages/community/article/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/article/[id]"])
      });
    }
  